import { Component, input, OnInit, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DTO, Types } from 'shared-lib';
import { AuthService } from './auth.service';
import { ToastService } from '../toast/toast.service';
import { LoadingService } from '../loading/loading.service';
import { EComponentSize, ELabelType, IComponentSection } from '../../types';
import { CommonModule } from '@angular/common';
import { DynamicFormComponent } from '../dynamic-form/dynamic-form.component';
import { Router } from '@angular/router';
import { helper } from '../../../public-api';

@Component({
  selector: 'app-auth',
  standalone: true,
  imports: [FormsModule, CommonModule, DynamicFormComponent],
  templateUrl: './auth.component.html',
  styleUrl: './auth.component.scss',
})
export class AuthComponent implements OnInit {
  fields = input<IComponentSection[]>([]);
  loading = signal(true);

  darkMode = false;
  avatar?: any;
  EComponentSize = EComponentSize;
  ELabelTypes = ELabelType;
  EAlert = Types.EAlert;
  currentFields = this.fields();

  constructor(
    private authService: AuthService,
    private loadingService: LoadingService,
    private toastService: ToastService,
    private router: Router
  ) {
    this.loadingService.stop();
    this.darkMode = helper.Functions.isDarkMode();
  }

  ngOnInit(): void {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', () => {
        this.darkMode = helper.Functions.isDarkMode();
      });

    const personalInfo = {
      name: 'Login',
      selector: 'login',
      content: [
        {
          component: 'TextComponent',
          selector: 'login',
          inputs: {
            placeHolder: 'Seu email, CPF ou telefone',
            default: '',
            value: '',
            type: Types.EInput.TEXT,
            required: true,
          },
        },
        {
          component: 'TextComponent',
          selector: 'password',
          inputs: {
            placeHolder: 'Senha',
            default: '',
            value: '',
            type: Types.EInput.PASSWORD,
            required: true,
          },
        },
      ],
    };
    this.currentFields.unshift(personalInfo);
  }

  toRegister(){
    this.router.navigate(['/register']);
  }


  toResetPassword(){
    this.router.navigate(['/reset-password']);
  }

  onSubmit(event: any) {
    this.loadingService.start();

    const loginData = event['login'];

    let authInDTO = new DTO.AuthInDTO();
    authInDTO.identifier = loginData.login;
    authInDTO.password = loginData.password;
    
    this.authService.login(authInDTO).subscribe((success) => {
      this.loadingService.stop();
      if (!success) {
        this.toastService.add(
          `Não conseguimos processar seu login. Por favor, verifique suas credenciais de acesso!`,
          30000,
          'warning'
        );
        return;
      }
      this.toastService.add(
        `Autenticação concluída com êxito!`,
        30000,
        'success'
      );
    });
  }
}
